import { useCallback, useState } from "react";
import { FileRejection, useDropzone } from "react-dropzone";

import useToast from "@/contexts/toast-context";
import { ContactsMessages } from "@/messages/contacts/contacts.messages";

const spreadSheetTypes = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

interface useImportContactsProps {
  messages: ContactsMessages;
}

function useImportContacts({ messages }: useImportContactsProps) {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const { showToast } = useToast();

  const removeFile = () => {
    setUploadedFile(null);
  };

  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      const file = acceptedFiles[0];
      const fileRejection = fileRejections[0];

      if (fileRejection && !spreadSheetTypes.includes(fileRejection.file.type)) {
        showToast({ text: messages.unsupportedFileFormat, type: "error" });
        return;
      }

      if (!file) return;
      setUploadedFile(file);
    },
    [messages.unsupportedFileFormat, showToast]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.ms-excel": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    },
    maxFiles: 1,
  });

  return {
    uploadedFile,
    getRootProps,
    getInputProps,
    removeFile,
  };
}

export default useImportContacts;
